module.exports = __webpack_public_path__ + "static/media/PH3800__005_Intense-30 Sec.3c959b0b.mp3";